module.exports = __webpack_public_path__ + "static/wecancharge-3cea8504095366414cf6037e10f0f4cd.png";